import { createContext, useContext } from 'react';
import { ISearchTooltipContext } from './types';

export const SearchTooltipContext = createContext<ISearchTooltipContext>({} as ISearchTooltipContext);

export const useSearchTooltipContext = () => useContext(SearchTooltipContext);
